import React from 'react';
import { ApplePayLogo, GooglePayLogo, LinkLogo } from './StripeLogoSet';

export type WalletLogoProps = {
  stripeWalletType?: string;
  className?: string;
};

const renderLogo = (stripeWalletType?: string): React.ReactNode => {
  const normalizedStripeName = stripeWalletType?.toLowerCase();
  switch (normalizedStripeName) {
    case 'apple_pay':
      return (
        <div style={{ marginTop: '-10px', marginBottom: '-20px' }}>
          <ApplePayLogo />
        </div>
      );
    case 'google_pay':
      return (
        <div style={{ marginTop: '10px', marginBottom: '-5px' }}>
          <GooglePayLogo />
        </div>
      );
    default:
      return (
        <div style={{ marginTop: '10px' }}>
          <LinkLogo />
        </div>
      );
  }
};

const WalletLogo: React.FC<WalletLogoProps> = ({
  stripeWalletType,
  className = '',
}: WalletLogoProps) => {
  return (
    <div className={`${className} pointer-events-none`}>
      {renderLogo(stripeWalletType)}
    </div>
  );
};

export default WalletLogo;
